import { FormikProps } from 'formik';
import { MutableRefObject, Ref, useImperativeHandle } from 'react';
import { AnyObject } from 'yup';
import { BaseFormControls } from '../../GenericForm';

export function useFormControllerRefSetup<T extends AnyObject>(
  ref: Ref<BaseFormControls | null> | undefined,
  formikRef: MutableRefObject<FormikProps<Partial<T>> | null>
) {
  useImperativeHandle(ref, () => ({
    setFieldValue: (fieldName: string, value: string | number | AnyObject) => {
      formikRef.current?.setFieldValue(fieldName, value);
    },
    getFieldValue: (fieldName: string) => {
      return formikRef.current?.getFieldMeta(fieldName).value as
        | string
        | number
        | AnyObject;
    },
    getFormikBag: () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return formikRef as MutableRefObject<FormikProps<any>>;
    },
  }));
}
